import {
	Box,
	Button,
	Typography,
	CircularProgress,
	Grid,
	Dialog,
	DialogContent,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	DialogActions,
} from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
// import "../../shared/scss/components/bindModal.scss";
import QuoteSummaryProductsTable from "../QuoteSummaryProductsTable";
import { colours } from "../../shared/colors";
import { useQuoteContext } from "../../shared/contexts/QuoteContext";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { closeDialog } from "../../services/features/dialogSlice/dialogSlice";
/**
 * BindModal component displays a confirmation dialog for binding a quote.
 *
 * @param {Object} props - Component props.
 * @param {boolean} props.open - Determines whether the modal is open.
 * @param {Function} props.handleClose - Function to handle the modal close event.
 * @param {Function} props.handleBindQuote - Function to bind the quote.
 */
const BindModal = ({
	// open,
	// handleClose,
	handleBindQuote,
    options,
	// selectedProducts,
	// selectedPackages,
	// initialValues,
}: any) => {


    const dispatch = useDispatch();

    const openState = useSelector((state: RootState) => state.dialogSlice.open);
    const open = openState['bindQuote'];

    const handleClose = () => {
        dispatch(closeDialog('bindQuote'));
    }

    const { loading } = useQuoteContext();

	const values = [
		"You are authorised by your client to make this submission and to accept this quotation.",
		"You have provided all the relevant information including policy wording and additional endorsements and exclusions in the quotation to your client.",
		"You have read and understood the Important Notices to the Applicant.",
		"Where you have provided information about another person, you declare that the person has been made aware of that fact and of the Delta Insurance Australia's Privacy Statement.",
		"You confirm that the statements and information provided to Delta Insurance Australia are true and accurate.",
		"You understand that should information provided be misleading or fraudulent, the contract may be voided in its entirety as per the Insurance Contracts Act 1984.",
		"You understand that, up until a contract of insurance is entered into, you are under an ongoing obligation to immediately inform Delta Insurance Australia of any change in the facts or statements contained in this submission or in the accompanying documentation.",
		"You acknowledge that this information and any accompanying documents will form the basis of the contract.",
	];

	return (
		<Dialog
			open={open}
			onClose={(event, reason) => {
				if (reason && reason === "backdropClick") {
					return;
				}
				handleClose();
			}}
			scroll="paper"
			fullWidth
			sx={{
				"& .MuiDialog-container": {
					"& .MuiPaper-root": {
						width: "100%",
						maxWidth: "lg",
					},
				},
			}}
		>
			<DialogContent>
				<Grid container spacing={2}>
					<Grid item xs={12} sm={7}>
						<Box pb="1em">
							<Typography variant="cardContentHeader">
								Binding confirmation
							</Typography>
						</Box>
						<Typography
							variant="h5"
							sx={{
								fontWeight: 600,
								fontSize: "15px",
								lineHeight: "22px",
								color: colours.darkGrey.main,
							}}
						>
							By selecting 'Bind' cover will incept on the terms and conditions
							outlined in the quotation. Please read the following carefully and
							ensure that your client is aware of and has been advised of these
							statements before clicking the 'Bind' button:
						</Typography>
						<List dense>
							{values.map((option, i) => (
								<ListItem key={`bind-cover-option-${i}`}>
									<ListItemIcon sx={{ minWidth: "1em" }}>
										<CircleIcon sx={{ fontSize: "5px" }} />
									</ListItemIcon>
									<ListItemText primary={option} />
								</ListItem>
							))}
						</List>
					</Grid>
					<Grid item xs={12} sm={true}>
						<Box pb="1em">
							<Typography variant="cardContentHeader">
								Your Products and Limits
							</Typography>
						</Box>
						<QuoteSummaryProductsTable
                            options={options}
                            showCheckbox={false}
						/>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button variant="text" onClick={handleClose} disabled={loading}>
					Cancel
				</Button>
				<Button variant="contained" onClick={handleBindQuote} disabled={loading}>
					{loading ? (
						<Box
							display="flex"
							justifyContent="center"
							alignItems="center"
							minHeight="2em"
							px="0.5em"
							width="100%"
							position="relative"
						>
							<CircularProgress
								size={"2em"}
								sx={{
									color: "white",
									position: "absolute",
									zIndex: 1,
								}}
							/>
						</Box>
					) : (
						"Agree and Bind"
					)}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default BindModal;
